import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateCollections = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.1;}.d{fill:#fafcff;}.e{fill:#9ec5ff;}.f{fill:#dcebfe;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 249.11,
				cy: 253.53,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 113.67,
					y: 53.35,
					width: 280,
					height: 384.79,
					rx: 20,
					ry: 20
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M184.73,125.56c-.96-2.15-1.04-4.92-1.04-8.43s.07-6.29,1.04-8.44c1.29-2.89,4.03-4.88,8.03-4.88s6.73,2,8.03,4.88c.96,2.15,1.04,4.92,1.04,8.44s-.07,6.29-1.04,8.43c-1.29,2.89-4.03,4.88-8.03,4.88s-6.73-2-8.03-4.88Zm11.28-2.07c.48-1.07,.52-4,.52-6.36s-.04-5.29-.52-6.36c-.52-1.15-1.59-1.74-3.26-1.74s-2.74,.59-3.26,1.74c-.48,1.07-.52,4-.52,6.36s.04,5.29,.52,6.36c.52,1.15,1.59,1.74,3.26,1.74s2.74-.59,3.26-1.74Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M212.81,122.64c.04,.22,.07,.33,.18,.33h.15c.11,0,.15-.11,.19-.33l4.22-17.9c.07-.37,.37-.56,.7-.56h3.88c.48,0,.74,.22,.74,.56,0,.18-.04,.33-.15,.74l-6.44,24.05c-.11,.37-.37,.55-.7,.55h-4.96c-.33,0-.59-.19-.7-.55l-6.47-24.05c-.11-.41-.15-.55-.15-.74,0-.33,.26-.56,.74-.56h3.88c.33,0,.63,.19,.7,.56l4.18,17.9Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M226.57,130.08c-.41,0-.74-.33-.74-.74v-24.42c0-.41,.33-.74,.74-.74h13.43c.41,0,.74,.33,.74,.74v3.7c0,.41-.33,.74-.74,.74h-8.62c-.22,0-.37,.15-.37,.37v4.44c0,.22,.15,.37,.37,.37h8.32c.41,0,.74,.33,.74,.74v3.7c0,.41-.33,.74-.74,.74h-8.32c-.22,0-.37,.15-.37,.37v4.44c0,.22,.15,.37,.37,.37h8.77c.41,0,.74,.33,.74,.74v3.7c0,.41-.33,.74-.74,.74h-13.58Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M245.7,130.08c-.41,0-.74-.33-.74-.74v-24.42c0-.41,.33-.74,.74-.74h8.14c4.62,0,7.77,3.15,7.77,7.77,0,2.89-1.22,5.03-3.85,6.55-.26,.15-.41,.3-.41,.52,0,.15,.04,.33,.18,.7l3.81,8.8c.15,.37,.19,.48,.19,.7,0,.48-.37,.85-.93,.85h-3.7c-.48,0-.7-.15-.93-.67l-3.85-9.21c-.11-.3-.37-.48-.67-.48h-.96c-.22,0-.37,.15-.37,.37v9.25c0,.41-.33,.74-.74,.74h-3.7Zm7.95-15.54c1.52,0,2.59-1.07,2.59-2.59s-1.07-2.59-2.59-2.59h-3.14c-.22,0-.37,.15-.37,.37v4.44c0,.22,.15,.37,.37,.37h3.14Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M266.23,130.08c-.41,0-.74-.33-.74-.74v-24.42c0-.41,.33-.74,.74-.74h7.25c4,0,6.73,2.03,8.03,4.92,.96,2.15,1.04,4.7,1.04,8.03s-.07,5.88-1.04,8.03c-1.29,2.89-4.03,4.92-8.03,4.92h-7.25Zm7.25-5.22c1.67,0,2.74-.63,3.26-1.78,.48-1.07,.52-3.74,.52-5.96s-.04-4.88-.52-5.96c-.52-1.15-1.59-1.78-3.26-1.78h-2.44c-.22,0-.37,.15-.37,.37v14.72c0,.22,.15,.37,.37,.37h2.44Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M286.61,122.31v-17.39c0-.41,.33-.74,.74-.74h3.74c.41,0,.74,.33,.74,.74v17.39c0,1.63,1.26,2.92,3.33,2.92s3.4-1.29,3.4-2.92v-17.39c0-.41,.33-.74,.74-.74h3.74c.41,0,.74,.33,.74,.74v17.39c0,4.85-4,8.14-8.62,8.14s-8.55-3.29-8.55-8.14Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M309.51,130.08c-.41,0-.74-.33-.74-.74v-24.42c0-.41,.33-.74,.74-.74h13.43c.41,0,.74,.33,.74,.74v3.7c0,.41-.33,.74-.74,.74h-8.62c-.22,0-.37,.15-.37,.37v4.44c0,.22,.15,.37,.37,.37h8.32c.41,0,.74,.33,.74,.74v3.7c0,.41-.33,.74-.74,.74h-8.32c-.22,0-.37,.15-.37,.37v4.44c0,.22,.15,.37,.37,.37h8.77c.41,0,.74,.33,.74,.74v3.7c0,.41-.33,.74-.74,.74h-13.58Z"
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 140.14,
					y: 177,
					width: 171.29,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				}), /* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 333.46,
					y: 177,
					width: 33.78,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 140.14,
					y: 218.27,
					width: 171.29,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				}), /* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 333.46,
					y: 218.27,
					width: 33.78,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 140.14,
					y: 259.53,
					width: 171.29,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				}), /* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 333.46,
					y: 259.53,
					width: 33.78,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 140.14,
					y: 300.8,
					width: 171.29,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				}), /* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 333.46,
					y: 300.8,
					width: 33.78,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 140.14,
					y: 342.06,
					width: 171.29,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				}), /* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 333.46,
					y: 342.06,
					width: 33.78,
					height: 6.88,
					rx: 3.44,
					ry: 3.44
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M120.19,92.35H39.59c-15.54,0-28.14,12.6-28.14,28.14s12.6,28.14,28.14,28.14h57.91l4.06,12.05c.7,2.08,3.64,2.08,4.34,0l4.06-12.05h10.22c15.54,0,28.14-12.6,28.14-28.14s-12.6-28.14-28.14-28.14Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M114.1,88.24H33.49c-15.54,0-28.14,12.6-28.14,28.14s12.6,28.14,28.14,28.14h57.91l4.06,12.05c.7,2.08,3.64,2.08,4.34,0l4.06-12.05h10.22c15.54,0,28.14-12.6,28.14-28.14s-12.6-28.14-28.14-28.14Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("circle", {
							className: "f",
							cx: 40.33,
							cy: 116.52,
							r: 5.02
						}),
						/* @__PURE__ */ _jsx("circle", {
							className: "f",
							cx: 71.64,
							cy: 116.52,
							r: 5.02
						}),
						/* @__PURE__ */ _jsx("circle", {
							className: "f",
							cx: 102.94,
							cy: 116.52,
							r: 5.02
						})
					] })
				] }),
				/* @__PURE__ */ _jsx("circle", {
					className: "e",
					cx: 376.23,
					cy: 430.12,
					r: 42.76
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M379.48,448.82v2.43c0,.58-.47,1.06-1.06,1.06h-4.49c-.58,0-1.06-.48-1.06-1.06v-2.43c-5.76-1.16-9.51-5.39-9.51-11.2v-1.06c0-.58,.47-1.06,1.06-1.06h5.6c.58,0,1.06,.47,1.06,1.06v1.06c0,2.59,2.06,4.28,5.12,4.28s5.23-1.48,5.23-3.75c0-2.48-.95-3.7-7.77-5.5-6.66-1.74-9.46-5.65-9.46-11.2,0-4.81,3.28-8.77,8.67-9.99v-2.48c0-.58,.48-1.06,1.06-1.06h4.49c.58,0,1.06,.48,1.06,1.06v2.38c5.65,1.11,8.88,5.28,8.88,10.83v.26c0,.58-.48,1.06-1.06,1.06h-5.34c-.58,0-1.06-.47-1.06-1.06v-.26c0-2.33-1.85-3.91-4.44-3.91-2.96,0-4.6,1.22-4.6,3.43,0,1.9,1.32,3.17,7.45,4.76,7.08,1.85,9.78,5.5,9.78,11.15,0,5.92-3.7,10.09-9.62,11.2Z"
				})
			]
		})
	]
});
export default SvgEmptyStateCollections;
